import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=8ab30f5c"
import script from "./SidebarNavList.vue?vue&type=script&lang=js"
export * from "./SidebarNavList.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavList.vue?vue&type=style&index=0&id=8ab30f5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports